// Controls when the RM AI launcher greeting auto-opens. The launcher should
// greet a Platinum member once when they first log in / start a session, and
// again only after they've been idle/away for a while — never on every Discover
// visit. State:
//   - sessionStorage `rmAiLauncherShown`  → greeted at least once this session
//   - localStorage  `rmLastActiveAt`      → timestamp of last user activity
//
// shouldGreet() is true when we haven't greeted this session yet, OR the member
// has been idle past IDLE_MS (so returning after a break re-greets). Logout
// resets both keys so the next login greets fresh.

const SESSION_FLAG = 'rmAiLauncherShown'
const LAST_ACTIVE_KEY = 'rmLastActiveAt'

// Re-greet after this much inactivity. Adjust to taste.
export const IDLE_MS = 30 * 60 * 1000 // 30 minutes

// Throttle activity writes so we don't hit localStorage on every event.
let lastWrite = 0

export function markActivity() {
  const now = Date.now()
  if (now - lastWrite < 60_000) return
  lastWrite = now
  try {
    localStorage.setItem(LAST_ACTIVE_KEY, String(now))
  } catch {
    // ignore storage failures (private mode, quota, etc.)
  }
}

export function shouldGreet() {
  try {
    if (!sessionStorage.getItem(SESSION_FLAG)) return true
    const last = Number(localStorage.getItem(LAST_ACTIVE_KEY) || 0)

    return Date.now() - last > IDLE_MS
  } catch {
    return false
  }
}

export function markGreeted() {
  try {
    sessionStorage.setItem(SESSION_FLAG, '1')
    localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()))
  } catch {
    // ignore
  }
}

export function resetGreeting() {
  lastWrite = 0
  try {
    sessionStorage.removeItem(SESSION_FLAG)
    localStorage.removeItem(LAST_ACTIVE_KEY)
  } catch {
    // ignore
  }
}
